import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';

@Component({
    selector: 'app-eclesial-input-number',
    templateUrl: './eclesial.input.number.component.html',
})
export class EclesialInputNumberComponent implements OnInit {

    ngOnInit(): void {

        this.labelColSize = this.labelColSize;
        this.inputColSize = this.inputColSize;

        this.control = this.groupName ? this.formGroup.get(this.groupName).get(this.controlName) : this.formGroup.get(this.controlName);

        this.limit = Object.is(this.limit, undefined) || this.limit <= 0 ? 0 : this.limit;
    }

    @Input() formGroup: FormGroup;
    @Input() labelDescription: string;
    @Input() controlName: string;
    @Input() groupName: string;
    @Input() context: string = '';
    @Input() trySave: boolean;
    @Input() lastFocusControl: string;
    @Input() limit: number;
    @Input() place: string = '';

    @Input() isInactive: boolean = false;
    @Input() showLabel: boolean = true;

    @Input() labelColSize: string = 'col-6';
    @Input() inputColSize: string = 'col-6';

    @Output() lastFocusControlChange: EventEmitter<string> = new EventEmitter();

    public hasFocus: boolean;
    public control: AbstractControl;

    constructor( ) { }

    onFocus() {

        this.lastFocusControlChange.emit(this.controlName);
        this.hasFocus = true;
    }

    onFocusOut() {

        this.hasFocus = false;
        this.control.markAsDirty();
    }
}